export default {
  displaydate(m, alt) {
    if (m.length < 1) {
      m = alt;
    }
    let res = m.split(" ");
    let datetime = res[0];
    let time = res[1];

    let now = new Date();
    //let offsetMs = now.getTimezoneOffset() * 60 * 1000;
    //let dateLocal = new Date(now.getTime() - offsetMs);
    let currentdate = now.toLocaleDateString();

    var yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
    let yesterdayoffsetMs = yesterday.getTimezoneOffset() * 60 * 1000;
    let yesterdaydateLocal = new Date(yesterday.getTime() - yesterdayoffsetMs);
    let yesterdate = yesterdaydateLocal.toLocaleDateString();

    if (datetime === currentdate) {
      datetime = "Today";
    }
    if (datetime === yesterdate) {
      datetime = "Yesterday";
    }

    let str = datetime + ", " + time;
    return str;
  },

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [day, month, year].join('/');
  },

  formatDateAndTime(dateString) {
    var date = new Date(dateString);
    return this.formatDate(dateString) + " " + this.getTime(date);
  },

  isToday(date) {
    var today = new Date();

    return date.getDate() == today.getDate() &&
      date.getMonth() == today.getMonth() &&
      date.getFullYear() == today.getFullYear();
  },
  getTime(date) {
    var d = new Date(date),
      hour = '' + d.getHours(),
      min = '' + d.getMinutes();

    if (hour.length < 2)
      hour = '0' + hour;
    if (min.length < 2)
      min = '0' + min;

    return hour + ':' + min;
  },
  getMonth(date) {
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let d = new Date(date)
    return months[d.getMonth()];
  },

  getDay(date) {
    let d = new Date(date);
    return '' + d.getDate();
  },

  getYear(date) {
    let d = new Date(date);
    return d.getFullYear();
  },

  getDateAsNumber(string) {
    const str = string;
    const [dateComponents, timeComponents] = str.split(' ');

    const [day, month, year] = dateComponents.split('/');
    const [hours, minutes] = timeComponents.split(':');

    const date = new Date(+year, month - 1, +day, +hours, +minutes);
    return date;
  },

  getChartDate(date) {
    return [this.getDay(date), this.getMonth(date), this.getTime(date)];
  },
}

